import React from 'react';
import { SimpleSailing, SimpleSailingDay } from '@go-shared/types/sailing';
import { CalendarViewWeek } from './CalendarViewWeek/CalendarViewWeek';

interface CalendarViewProps {
  sailings: SimpleSailing[];
  selectedMonth: number;
  onContentBuilderClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onRundownClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayLock: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayStar: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayTemplateClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
}
export const CalendarView: React.FC<CalendarViewProps> = ({
  sailings,
  selectedMonth,
  onContentBuilderClick,
  onRundownClick,
  onSailingDayLock,
  onSailingDayStar,
  onSailingDayTemplateClick,
}) => {
  return (
    <>
      {sailings.map((sailing, i) => (
        <CalendarViewWeek
          key={i}
          sailing={sailing}
          selectedMonth={selectedMonth}
          onRundownClick={onRundownClick}
          onContentBuilderClick={onContentBuilderClick}
          onSailingDayLock={onSailingDayLock}
          onSailingDayStar={onSailingDayStar}
          onSailingDayTemplateClick={onSailingDayTemplateClick}
        />
      ))}
    </>
  );
};
